import { render, staticRenderFns } from "./BaseCardGrid.vue?vue&type=template&id=0f70f5a3&scoped=true&"
import script from "./BaseCardGrid.vue?vue&type=script&lang=js&"
export * from "./BaseCardGrid.vue?vue&type=script&lang=js&"
import style0 from "./BaseCardGrid.vue?vue&type=style&index=0&id=0f70f5a3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f70f5a3",
  null
  
)

export default component.exports